import { GET_FAQ } from "./types";

export const getFaq = (search_string) => dispatch => {
  return fetch(`/api/faq/get_faq${search_string}`)
    .then(res => res.json())
    .then(faq_res => dispatch({ type: GET_FAQ, payload: faq_res.msg }));
};
